import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import { Col, Row, Button } from "reactstrap";
import Header from "../../layout/Header/Header";

function BotonesInventarios() {
  const { user } = useContext(AuthContext);

  const Btn = ({ permitido, href, icon, label }) => (
    <Col md={4} align="center">
      {permitido ? (
        <Button href={href} className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      ) : (
        <Button disabled className="botonesMenu" color="success">
          <i className={`fas ${icon} fa-7x`}></i>
          <br />
          <br />
          {label}
        </Button>
      )}
    </Col>
  );

  const Seccion = ({ titulo }) => (
    <>
      <br />
      <h4
        style={{
          borderBottom: "2px solid #f28029",
          paddingBottom: 6,
          marginBottom: 16,
          color: "#333",
        }}
      >
        {titulo}
      </h4>
    </>
  );

  return (
    <>
      <Header />
      {user.menu_inventarios ? (
        <div className="container">
          <br />

          {/* ===== INVENTARIO ===== */}
          <Seccion titulo="Inventario" />
          <Row>
            <Btn permitido={user.inventarios} href="/ListadoInventarios" icon="fa-warehouse" label="Inventario" />
            <Btn permitido={user.inventarios} href="/ListadoInventariosCostos" icon="fa-dollar-sign" label="Inventario Costos" />
            <Btn permitido={user.menu_disponible} href="/ListadoDisponible" icon="fa-tasks" label="Disponible" />
          </Row>
          <br />
          <Row>
            <Btn permitido={user.seguimiento_inventarios} href="/ListadoTracking" icon="fa-search" label="Tracking" />
            <Btn permitido={user.seguimiento_inventarios} href="/ListadoKardex" icon="fa-clipboard-list" label="Kardex" />
          </Row>

          {/* ===== MOVIMIENTOS ===== */}
          <Seccion titulo="Movimientos" />
          <Row>
            <Btn permitido={user.menu_traspasos_salida} href="/ListadoTraspasosSalida" icon="fa-sign-out-alt" label="Traspasos Salida" />
            <Btn permitido={user.menu_traspasos_entrada} href="/ListadoTraspasosEntrada" icon="fa-sign-in-alt" label="Traspasos Entrada" />
            <Btn permitido={user.ajustesInventario} href="/ListadoAjustesInventario" icon="fa-plus" label="Ajuste Inventario" />
          </Row>

          {/* ===== REPORTES ===== */}
          <Seccion titulo="Reportes" />
          <Row>
            <Btn permitido={user.inventarios} href="/ReporteUltimoPrecio" icon="fa-dollar-sign" label="Ultimo Precio Cliente" />
            <Btn permitido={user.inventarios} href="/ReporteUltimoPrecioArticulo" icon="fa-dollar-sign" label="Ultimo Precio Articulo" />
          </Row>

          {/* ===== CATÁLOGOS ===== */}
          <Seccion titulo="Catálogos" />
          <Row>
            <Btn permitido={true} href="/Areas" icon="fa-store" label="Almacenes" />
          </Row>

          <br />
          <br />
        </div>
      ) : undefined}
    </>
  );
}

export default BotonesInventarios;
